import React, { VFC, ReactNode } from 'react';

import styles from './MasterSearchBar.module.scss';

type Props = {
  title: string;
  children: ReactNode;
};

const MasterSearchSubsection: VFC<Props> = ({ title, children }: Props) => {
  return (
    <li className={styles.searchSubsection}>
      <div className={styles.searchSubsectionTitle}>{title}</div>
      <div className={styles.searchSubsectionResult}>{children}</div>
    </li>
  );
};

export default MasterSearchSubsection;
